<template>
  <div class="basicInfoAgentDetail">
    <van-form label-width="120px" :show-error="false" @submit="onSubmit">
      <van-field
        clickable
        readonly
        :value="selectedCity.text"
        :label="$t.meta.city"
        :placeholder="OAId ? '' : $t.meta.select"
        @click="onShowEmit('showBasicInfoAgentDetailCity')"
        required
        :rules="formRule"
      />
      <div class="agent-detail-radio">
        <div class="radio-label">{{ $t.meta.wbType1 }}</div>
        <van-radio-group
          v-model="form.IsAir"
          direction="horizontal"
          :disabled="OAId ? true : false"
        >
          <van-radio name="1" @click="swithChange('isAir')">{{ $t.meta.yes }}</van-radio>
          <van-radio name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>
      <div class="agent-detail-radio">
        <div class="radio-label">{{ $t.meta.wbType2 }}</div>
        <van-radio-group
          v-model="form.IsSea"
          direction="horizontal"
          :disabled="OAId ? true : false"
        >
          <van-radio name="1" @click="swithChange('isSea')">{{ $t.meta.yes }}</van-radio>
          <van-radio name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>
      <div class="agent-detail-radio">
        <div class="radio-label">{{ $t.meta.wbType6 }}</div>
        <van-radio-group
          v-model="form.IsRailway"
          direction="horizontal"
          :disabled="OAId ? true : false"
        >
          <van-radio name="1" @click="swithChange('isRailway')">{{
            $t.meta.yes
          }}</van-radio>
          <van-radio name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>
      <div class="agent-detail-radio">
        <div class="radio-label">{{ $t.meta.wbType7 }}</div>
        <van-radio-group
          v-model="form.IsWarehouse"
          direction="horizontal"
          :disabled="OAId ? true : false"
        >
          <van-radio name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>
      <div class="agent-detail-radio">
        <div class="radio-label">{{ $t.meta.wbType8 }}</div>
        <van-radio-group
          v-model="form.IsCustomBorkerAgent"
          direction="horizontal"
          :disabled="OAId ? true : false"
        >
          <van-radio name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>
      <div class="agent-detail-radio">
        <div class="radio-label">{{ $t.meta.wbType9 }}</div>
        <van-radio-group
          v-model="form.IsPickUpDelivery"
          direction="horizontal"
          :disabled="OAId ? true : false"
        >
          <van-radio name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>
      <div class="agent-detail-radio">
        <div class="radio-label">{{ $t.meta.isConsolidation }}</div>
        <van-radio-group
          v-model="form.IsConsolidation"
          direction="horizontal"
          :disabled="OAId ? true : false"
        >
          <van-radio name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>

      <van-field
        v-model="form.CompanyName"
        :label="$t.basicInfo.companyName"
        :placeholder="OAId ? '' : $t.meta.input"
        :disabled="OAId ? true : false"
      />

      <van-field
        v-model="form.ContactPhone"
        :label="$t.basicInfo.phoneNumber"
        :placeholder="OAId ? '' : $t.meta.input"
        :disabled="OAId ? true : false"
      />

      <van-field
        v-model="form.Contacts"
        :label="$t.basicInfo.contact"
        :placeholder="OAId ? '' : $t.meta.input"
        :disabled="OAId ? true : false"
      />

      <van-field
        v-model="form.Email"
        :label="$t.basicInfo.email"
        :placeholder="OAId ? '' : $t.meta.input"
        :disabled="OAId ? true : false"
      />

      <van-field
        v-model="form.Address"
        :label="$t.basicInfo.address"
        :placeholder="OAId ? '' : $t.meta.input"
        type="textarea"
        :disabled="OAId ? true : false"
      />

      <van-field
        v-model="form.OperatingNotes"
        :label="$t.basicInfo.notes"
        :placeholder="OAId ? '' : $t.meta.input"
        type="textarea"
        :disabled="OAId ? true : false"
      />

      <div style="margin: 16px" v-if="!OAId">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.submit
        }}</van-button>
      </div>
    </van-form>

    <option-list
      event="showBasicInfoAgentDetailCity"
      :options="cityList"
      @onSelect="onSelectCity"
    ></option-list>
  </div>
</template>
<script>
import Vue from "vue";
import OptionList from "@components/optionList/OptionList.vue";
import { Form, Field, Button, Icon, Image, Radio, RadioGroup } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image).use(Radio).use(RadioGroup);

export default {
  name: "basicInfoAgentDetail",
  components: {
    OptionList,
  },
  data() {
    return {
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      OAId: "",
      customerNumber: "",
      form: {
        CityId: "",
        CityName: "",
        IsAir: true,
        IsSea: false,
        IsRailway: false,
        IsWarehouse: false,
        IsCustomBorkerAgent: false,
        IsPickUpDelivery: false,
        IsConsolidation: false,
        CompanyName: "",
        Address: "",
        ContactPhone: "",
        Contacts: "",
        Email: "",
        OperatingNotes: "",
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      cityList: [],
      selectedCity: { text: "", value: null },
    };
  },
  created() {
    const { OAId, CustomerNumber } = this.$route.query;
    if (OAId) {
      this.OAId = OAId;
      this.getOverseasAgentInfo().then((success) => {
        if (success) {
          this.getOptions().then((success) => {
            if (success) {
              var city = this.cityList.find((c) => c.value == this.form.CityId);
              if (city) {
                this.selectedCity.text = city.text;
                this.selectedCity.value = city.value;
              }
            }
          });
        }
      });
    } else {
      this.customerNumber = CustomerNumber;
      this.getOptions();
    }
  },
  methods: {
    swithChange(value) {
      if (value == "isAir") {
        this.form.IsSea = "0";
        this.form.IsRailway = "0";
      }
      if (value == "isSea") {
        this.form.IsAir = "0";
        this.form.IsRailway = "0";
      }
      if (value == "isRailway") {
        this.form.IsSea = "0";
        this.form.IsAir = "0";
      }
      this.selectedCity.text = "";
      this.selectedCity.value = null;
      this.getCityList();
    },
    onSelectCity(item) {
      this.selectedCity.text = item.text;
      this.selectedCity.value = item.value;
    },
    onShowEmit(emit) {
      if (!this.OAId) this.$bus.$emit(emit, true);
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      param.CustomerNumber = this.customerNumber;
      param.CreateUserId = this.UserId;
      param.CityId = this.selectedCity.value;
      this.$api.customerManagement
        .addOverseasAgentInfo(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getOverseasAgentInfo() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          OAId: this.OAId,
        };
        this.$api.customerManagement
          .getOverseasAgentInfo(param)
          .then((res) => {
            this.form = res.data;
            this.form.IsAir = this.form.IsAir ? "1" : "0";
            this.form.IsSea = this.form.IsSea ? "1" : "0";
            this.form.IsRailway = this.form.IsRailway ? "1" : "0";
            this.form.IsWarehouse = this.form.IsWarehouse ? "1" : "0";
            this.form.IsCustomBorkerAgent = this.form.IsCustomBorkerAgent ? "1" : "0";
            this.form.IsPickUpDelivery = this.form.IsPickUpDelivery ? "1" : "0";
            this.form.IsConsolidation = this.form.IsConsolidation ? "1" : "0";
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    getOptions() {
      return new Promise((resolve) => {
        Promise.all([this.getCityList()]).then((success) => {
          if (success) resolve(true);
        });
      });
    },
    getCityList() {
      return new Promise((resolve) => {
        this.$api.logisticsManagement
          .getCountryList({
            type: this.form.IsAir == "1" ? 1 : 2,
          })
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.City_cn + "," + item.City_en,
                value: item.Id,
              };
              result.push(data);
            });
            this.cityList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.basicInfoAgentDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }

  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }

  .van-cell::after {
    border: none !important;
  }

  ::v-deep .van-radio__icon--disabled.van-radio__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }

  ::v-deep .van-radio__label--disabled.van-radio__label {
    color: #323233 !important;
    -webkit-text-fill-color: #323233 !important;
  }

  ::v-deep .van-checkbox__icon--disabled.van-checkbox__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }

  ::v-deep .van-checkbox__label--disabled.van-checkbox__label {
    color: #323233 !important;
    -webkit-text-fill-color: #323233 !important;
  }

  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #323233 !important;
      -webkit-text-fill-color: #323233 !important;
    }
  }

  .agent-detail-radio {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;

    .radio-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }

    .van-radio {
      margin-right: 20px;
      font-size: 14px;
    }
  }
}
</style>
